import { render, staticRenderFns } from "./ExpensesInput.vue?vue&type=template&id=05c380f8&"
import script from "./ExpensesInput.vue?vue&type=script&lang=js&"
export * from "./ExpensesInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports